import saveStatusValues from 'constants/status.save'
export default (state = {
	redirect: () => { },
	redirectReplace: () => { },
	contrast: false,
	largeText: false,
	clientColors: null,
	isMenuOpen: true,
	saveStatus: saveStatusValues.CLOSED,
	saveStatusMessage: '',
	openTutorial: false,
}, { type, payload }) => {
	switch (type) {

		case 'SET_STORE_VALUE':
			return {
				...state,
				[payload.id]: payload.value,
			}
		case 'SET_STORE_MULTI_VALUE':

			return {
				...state,
				...payload,
			}
		default:
			return state
	}
}
